import {createAction} from 'util/redux'

import {SharedAppState} from 'module/SharedAppState/type/SharedAppState'

const NAMESPACE = 'SHARED_APP_STATE/'
export const sharedAppStateSetAction = createAction<SharedAppState>(NAMESPACE + 'Set')
